export default "__VITE_ASSET__CivTuwBq__"